/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../../../core/tivo/tivo-redux-wrapper';
import { IAutoplayNextEpisodeSelectedOption } from './IAutoplayNextEpisodeSelectedOption';
import {
    SET_AUTOPLAY_NEXT_EPISODE_OPTIONS_LIST,
    SET_AUTOPLAY_NEXT_EPISODE_SELECTED_OPTION,
} from './userprefautoplaynextepisode.types';

export const setAutoplayNextEpisodeListAction = (
    optionsList: Array<IAutoplayNextEpisodeSelectedOption>,
): TivoPayloadAction<{
    optionsList: Array<IAutoplayNextEpisodeSelectedOption>;
}> => ({
    type: SET_AUTOPLAY_NEXT_EPISODE_OPTIONS_LIST,
    payload: { optionsList },
});

export const setSelectedAutoplayNextEpisodeOptionAction = (
    selectedOption?: IAutoplayNextEpisodeSelectedOption,
): TivoPayloadAction<{ selectedOption?: IAutoplayNextEpisodeSelectedOption }> => ({
    type: SET_AUTOPLAY_NEXT_EPISODE_SELECTED_OPTION,
    payload: { selectedOption },
});
